import React, { Fragment, useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import swal from 'sweetalert';
import axios from "axios";
import { Badge } from "react-bootstrap";
import { IMAGES, SVGICON } from '../../src/jsx/constant/theme';
import Cars from '../components/Usercars';
import { useParams } from 'react-router-dom';
import useRef from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Popover,
  Dropdown,
  Form,
  Button,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { Tab, Nav, ListGroup } from "react-bootstrap";
import { Modal } from 'react-bootstrap';
import { First } from 'react-bootstrap/esm/PageItem';

const messageBlog = [
  { id: '01' }, { id: '02' }, { id: '03' }, { id: '04' }, { id: '05' },
  { id: '06' }, { id: '07' }, { id: '08' }, { id: '09' }, { id: '10' },
  { id: '11' }, { id: '12' }, { id: '13' }, { id: '14' }, { id: '15' },
  { id: '16' }, { id: '17' }, { id: '18' }, { id: '19' }, { id: '20' },
  { id: '21' }, { id: '22' }, { id: '23' }, { id: '24' }, { id: '25' },
  { id: '26' }, { id: '27' }, { id: '28' }, { id: '29' }, { id: '30' }
];

const Orders = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const [vehicle, setVehicle] = useState('');
  const [date, setDate] = useState('');
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  //   useEffect(() => {
  //   const interval = setInterval(async () => {
  //     const res = await axios.get(`/api/appointments/notifications/${customerId}`);
  //     setNotifications(res.data);
  //   }, 5000);

  //   return () => clearInterval(interval); // cleanup
  // },  [customerId]);
  const [time, setTime] = useState("");
  const [customerNote, setCustomerNote] = useState("");
  const { CustomerID } = useParams(); // Extract CustomerID from the URL
  const [scheduled, setScheduled] = useState([]);
  const [inviteModal, setInviteModal] = useState("hidden");
  const [inviteModal1, setInviteModal1] = useState(true);
  const [listItem, setlistItem] = React.useState([])
  const [listItem1, setlistItem1] = useState([])
  const [popupModal, setpopupModal] = useState(false);
  const [orders, setOrders] = useState([]);
  const [nextAppointment, setNextAppointment] = useState(null);

  useEffect(() => {
    // بيانات تجريبية (Mock Data)
    const mockData = {
      id: 1,
      date: "2025-09-10",
      time: "10:30 صباحًا",
      service: "صيانة دورية",
      car: "تويوتا كورولا 2020"
    };

    // هذي بس تجربة كأنها جاية من API
    setNextAppointment(mockData);
  }, []);
  // Get the next upcoming maintenance date
  const getNextMaintenance = () => {
  //   if (!orders?.vehicles?.length) return null;

  //   // Flatten all scheduled maintenances from all vehicles
  //   const allSchedules = orders.vehicles.flatMap(vehicle =>
  //     vehicle.scheduled_maintenances.map(schedule => ({
  //       ...schedule,
  //       vehicle: vehicle, // attach vehicle info for display
  //     }))
  //   );

  //   if (!allSchedules.length) return null;

  //   // Sort by NextDate ascending
  //   const sortedSchedules = allSchedules.sort((a, b) => new Date(a.NextDate) - new Date(b.NextDate));

  //   // Return the first one (the soonest)
  //   return sortedSchedules[0];
const thresholdDays = 30; // days before to show alert
let upcomingSchedule = null;

if (orders?.vehicles?.length > 0) {
  const allSchedules = orders.vehicles.flatMap(vehicle =>
    vehicle.scheduled_maintenances?.map(schedule => ({
      ...schedule,
      vehicle: vehicle,
      NextDateObj: new Date(schedule.NextDate)
    })) || []
  );

  const futureSchedules = allSchedules.filter(sch => sch.NextDateObj >= new Date());

  if (futureSchedules.length > 0) {
    // Sort by date ascending
    futureSchedules.sort((a, b) => a.NextDateObj - b.NextDateObj);
    const nextSch = futureSchedules[0];

    // Check if within threshold
    const diffTime = nextSch.NextDateObj - new Date();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays <= thresholdDays) {
      upcomingSchedule = nextSch;
      return nextSch;
    }
  }
}


}
   
   
   ;

  const nextSchedule = getNextMaintenance();

  //   useEffect(() => {
  //     // Fetch data for the given CustomerID
  //     fetch(`https://subk.education.com.ly/back/api/customers/${CustomerID}`)
  //       .then((response) => response.json())
  //       .then((data) => setOrders(data))
  //       .catch((error) => console.error('Error fetching orders:', error));
  //   }, [CustomerID]);
  useImperativeHandle(ref, () => ({
    showInviteModal() {
      setInviteModal("hidden")
      setInviteModal1(true)

    }
  }));


  useEffect(() => {
    const token = localStorage.getItem("customerToken");

    if (!token) {
      navigate("/"); // redirect if no token
      return;
    }


    axios
      .post("https://subk.education.com.ly/back/api/customer-data", { token })
      .then((res) => {
        setOrders(res.data);
        setScheduled(res.data.vehicles.scheduledMaintenances || []);
        fetch(`https://subk.education.com.ly/back/api/invoices/repair-order/${res.data.CustomerID}`) // Replace with your actual API endpoint
          .then((response) => response.json())
          .then((data) => {
            setInvoices(data);

            // Dynamically assign colors based on RepairOrderID
            const uniqueIds = [...new Set(data.map((item) => item.RepairOrderID))];
            const newColorMap = {};
            uniqueIds.forEach((id, index) => {
              newColorMap[id] = colors[index % colors.length]; // Cycle through the colors
            });
            setColorMap(newColorMap);
          })
          .catch((error) => console.error("Error fetching invoices:", error));
     fetchNotifications(res.data.CustomerID); 
    // Compute next upcoming maintenance within a threshold


    
    })
      .catch(() => navigate("/UserPage")) // redirect if invalid token
      .finally(() => setLoading(false));
  }, [navigate]);

  const location = useLocation();
  const location2 = useLocation();
  const [itemName, setItemName] = useState('');

  const [cName, setCName] = useState('');
  const [last, setlast] = useState(0)
  console.log("Location search:", orders.vehicles);
  const searchParamscoust = new URLSearchParams(location2.search);
  const receivedDataArrayss = JSON.parse(searchParamscoust.get('data')) || [];

  const receivedcoustId = searchParamscoust.get('id') || '';
  const receivedcoustname = searchParamscoust.get('cname') || '';
  const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  console.log('fffffff', receivedDataArrayss)

  // Parse the JSON string back to an array
  const userPermissions = JSON.parse(userPermissionsJSON);
  // Function to search for permissions for a specific page
  function getActionsForPage(pageName) {
    // Find the permissions object for the given page
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    console.log('actionsForPage', pagePermissions);

    // If permissions for the page are found, return the actions
    if (pagePermissions) {
      return pagePermissions.action;
    } else {
      navigate('/dashboard_1')

      return [];
    }
  }

  // Usage
  const pageName = 'Orders';
  const actionsForPage = getActionsForPage(pageName);

  const [data, setData] = useState([])
  const [qun, setQun] = useState(0)
  const [data1, setData1] = useState([])
  const [total, setTotal] = useState(0)
  const [atbak, setAtbak] = useState([])
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);

  // Polling every 5 seconds
     const fetchNotifications = async (id) => {
      try {
        const res = await axios.get(`https://subk.education.com.ly/back/api/appointments/notifications/${id}`);
        setNotifications(res.data);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

     // initial fetch

 

  const showInviteModal1 = () => {

    setInviteModal1(false)
    setInviteModal("Block")
  }
  const notifyInfo = () => {
    swal({
      title: "هل متاكد من الغاء هده العملية",
      text:
        "بمجرد الضفظ على نعم سيتم اعادة توجيهك الى الصفحه الرئيسية",
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      dangerMode: true,
      confirmButtonAriaLabel: 'نعم',
      cancelButtonText: "العودة",
    }).then((willDelete) => {
      if (willDelete) {
        navigate('/dashboard_1')
      } else {
        setInviteModal(false)
      }
    })

  }

  const handleDelete = (index) => {
    // Create a copy of the list
    const updatedList = [...listItem];

    // Remove the item at the specified index
    updatedList.splice(index, 1);
    const totalAA = updatedList.reduce((total, item) => total + item.aa, 0);
    setTotal(totalAA);
    // Update the state with the new list
    setlistItem(updatedList);
  };

  const [colorMap, setColorMap] = useState({}); // Map for RepairOrderID to colors
  const colors = ["#f8d7da", "#d4edda", "#cce5ff", "#fff3cd", "#e2e3e5"];
  const [catigorydata, setCatigorydata] = useState([])
  const input = document.querySelector('input[name="city"]');
  if (input) {
    input.addEventListener('invalid', function (event) {
      if (event.target.validity.valueMissing) {
        event.target.setCustomValidity('الرجاء ادخال  القيمة');
      }
    })

    input.addEventListener('change', function (event) {
      event.target.setCustomValidity('');
    })
  }






  const [activeTab, setActiveTab] = useState('cars');




  const [errors, setErrors] = useState('')



  const [Name, setName] = useState('');
  const [ItemPrice, setItemPrice] = useState('');
  const [ItemID, setItemID] = useState('');
  const [TItemID, setTItemID] = useState('');
  const [TName, setTName] = useState('');
  const [TabakName, setTabakName] = useState('');
  const [AtbakID, setAtbakID] = useState('');
  const [FoodCategoryID, setFoodCategoryID] = useState('');



  // const queryString = new URLSearchParams({ data: JSON.stringify(listItem) }).toString();

  const [city, setCity] = useState([])
  console.log('listItemlistItemlistItemlistItem', listItem)
  const queryString = new URLSearchParams({
    data: JSON.stringify(listItem),
    id: last.toString(),
    cname: cName,
    //total:total,

  }).toString();
  console.log('queryString', queryString)


  const userdata = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata);
  const userid = userData.id;
  const [customers, setCustomers] = useState({
    CustomerID: '',
    CustomerName: '',
    Notes: 'ww',
    AreaID: '',
    PhoneNumber: '',
    PhoneNumber1: '22',
    PhoneNumber2: '11',
    UserID: userid,
  });



 

  const styles1 = {
    notification: { 
marginTop: '0px',
      marginRight: "20px",
marginBottom: '10px',
marginLeft: '20px',
width: "89%",
      background: "linear-gradient(to right, #FEF3C7, #FDE68A, #FACC15)",
      borderLeft: "8px solid #D97706",
      color: "#78350F",
      padding: "3px",
      borderRadius: "12px",
      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
      marginBottom: "24px",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      animation: "pulse 2s infinite"
    },
    icon: {
      fontSize: "28px",
      animation: "bounce 2s infinite"
    },
    text: {
      display: "flex",
      flexDirection: "column",
      lineHeight: "1.5"
    }
  };
  if (!nextAppointment) return null;

  const cardBlog = [
    { svg: <i class="fa-solid fa-address-card" style={{ color: 'green' }}></i>, number: `${orders.FirstName || ''} ${orders.LastName || ''}`, title: orders.Phone, changetheme: 'success' },
  ];
  const netwrokBlog = [
    { image: IMAGES.dribble, title: 'Dribble', price: '12,348', bg: 'primary', percent: '+36' },
    { image: IMAGES.facebook, title: 'Facebook', price: '10,048', bg: 'danger', percent: '+33' },
    { image: IMAGES.instagram, title: 'Instagram', price: '09,059', bg: 'info', percent: '-10' },

  ];
  const stylesold = {
    button: {
      position: "fixed",
      bottom: "30px",
      left: "30px",
      background: "linear-gradient(45deg, #3fb2f4ff, #4dfcdfff, #3B82F6)",
      color: "#fff",
      padding: "16px 24px",
      borderRadius: "50px",
      fontWeight: "bold",
      fontSize: "16px",
      boxShadow: "0 8px 15px rgba(0,0,0,0.2)",
      border: "none",
      cursor: "pointer",
      zIndex: 1000,
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      animation: "pulse-fab 2s infinite"
    },
    icon: {
      fontSize: "20px",
      animation: "bounce-fab 2s infinite"
    }
  };
  const styles = {
    button: {
marginTop    :"14px",
  display: "flex",
     // position: "fixed",
      top: "15px",
      right: "20px",
      gap: "10px",
        background:"linear-gradient(45deg, rgb(248, 185, 64), rgb(252, 211, 77), rgb(248, 185, 64))",
      color: "#fff",
      fontWeight: "bold",
      fontSize: "12px",
      padding: "10px",
      borderRadius: "50px",
      border: "none",
      cursor: "pointer",
      boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
      transition: "transform 0.3s, box-shadow 0.3s",
      animation: "pulse 2s infinite",
    },
    icon: {
      fontSize: "22px",
      animation: "bounce 2s infinite",
    },
  };
const handleTakeAppointment = async (schedule, vehicle) => {
  try {
    const payload = {
      customer_id: orders.CustomerID, // or the logged-in customer ID
      vehicle_id: vehicle.VehicleID,
      date: schedule.NextDate,
          UserID: userid,

      time: schedule.NextTime || "09:00", // fallback if time exists
      service_ids: schedule.repair_details.map(d => d.ServiceID),
      customer_note: "تم الحجز تلقائياً بناءً على الصيانة القادمة",
    };

    const response = await axios.post("https://subk.education.com.ly/back/api/appointments", payload);
    alert("تم حجز الموعد بنجاح!");
  } catch (error) {
    console.error("خطأ في حجز الموعد:", error);
    alert("حدث خطأ أثناء حجز الموعد");
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post("https://subk.education.com.ly/back/api/appointments", {
        customer_id: orders.CustomerID,
        date,
        time,
        customer_note: customerNote,
            UserID: userid,

      });
      handleClose();
    } catch (error) {
      console.error(error);
      alert("حدث خطأ أثناء إضافة الموعد");
    } finally {
      setLoading(false);
    }
  };
  return (

    <>
      <div className="" id="exampleModal1" style={{ visibility: { inviteModal } }} centered>

        <div className="container-fluid " style={{ padding: '0.500rem' }}>
          <div className="row">
            {/* {cardBlog.map((item, ind) => (
              <div className="col-xl-12" key={ind}>
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between">
                      <div  >
                        <button onClick={handleShow} style={styles.button}  >
                          
                          حجز موعد
                        </button>                                        </div>


                      <div className="total-projects ms-3">
                        <h6 className={`count text-${item.changetheme}`}>{item.number}</h6>
                        <span>{item.title}</span>
                      </div>
                   
                    <li className="nav-item dropdown notification_dropdown">
                      <Dropdown className="header-profile2">
                        <Dropdown.Toggle className="nav-link i-false c-pointer" variant="" as="a">
                          {SVGICON.BellIcon}
                          <Badge as="a" href="#" bg="primary" className="badge-circle">
                            {notifications.length}
                          </Badge>
                        </Dropdown.Toggle>

                        <Dropdown.Menu align="end" className="notification-dropdown" style={{width:'300px'}}>
                          {notifications.length > 0 ? (
                            notifications.map((n) => (
                              <div key={n.id} className="dropdown-item">
                                <div className="d-flex">
                                  <div className="me-2">
                                    <i className="fa fa-calendar-check text-success"></i>
                                  </div>
                                  <div>
                                    <strong>موعدك:</strong> {n.AppointmentDate} - {n.appointment_time}
                                    <br />
                                    <strong>حالة:</strong> {n.Status }
                                    {n.AdminNote && (
                                      <>
                                        <br />
                                        <strong>ملاحظات المدير:</strong> {n.AdminNote}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="dropdown-item text-center">لا توجد إشعارات جديدة</div>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  </div> </div>
                </div>
              </div>
            ))} */}

   {cardBlog.map((item, ind) => (
    <div className="col-lg-12 mb-4" key={ind}>
      <div className="card h-100">
        <div className="card-body d-flex align-items-center justify-content-between mb-3">
  <div className="col-4 d-flex justify-content-start">
    <button onClick={handleShow} style={styles.button}>
      حجز موعد
    </button>
  </div>

  <div className="col-4 d-flex flex-column align-items-center">
    <h6 className={`count text-${item.changetheme}`}>{item.number}</h6>
    <span>{item.title}</span>
  </div>

  <div className="col-4 d-flex justify-content-end">
    <li className="nav-item dropdown notification_dropdown list-unstyled">
      <Dropdown className="header-profile2">
        <Dropdown.Toggle className="nav-link i-false c-pointer" variant="" as="a">
          {SVGICON.BellIcon}
          <Badge as="a" href="#" bg="primary" className="badge-circle">
            {notifications.length}
          </Badge>
        </Dropdown.Toggle>

        <Dropdown.Menu align="end" className="notification-dropdown" style={{ width: '300px' }}>
          {notifications.length > 0 ? (
            notifications.map((n) => (
              <div key={n.id} className="dropdown-item" style={{borderBottom:'gray solid 1px'}}>
                <div className="d-flex">
                  <div className="me-2">
                    <i className="fa fa-calendar-check text-success"></i>
                  </div>
                  <div>
                    <strong>موعدك:</strong> {n.AppointmentDate} - {n.appointment_time}
                    <br />
                    <strong>حالة:</strong> {n.Status}
                    {n.AdminNote && (
                      <>
                        <br />
                        <strong>ملاحظات المدير:</strong> {n.AdminNote}
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="dropdown-item text-center">لا توجد إشعارات جديدة</div>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </li>
  </div>
</div>

      </div>
    </div>
  ))}
 
          </div>
          {/* إشعار الموعد القادم */}
{nextSchedule &&
          <div style={styles1.notification}>
            <span style={styles1.icon}>🔔</span>
            <div style={styles1.text}>
              <strong>تنبيه:</strong> لديك موعد صيانة قريب!
              {nextSchedule
                ? ` ${nextSchedule.NextDate} - ${nextSchedule.vehicle.make.MakeName} ${nextSchedule.vehicle.vehicle_model.ModelName} - ${nextSchedule.repair_details.map(d => d.service.ServiceName).join(", ")}`
                : 'لا توجد مواعيد صيانة قادمة'}
            </div>
          </div>}

          {/* زر الحجز */}

          <div className="row">
            <div className="col-lg-12">
              <div className="card mb-0 h-auto">
                <div className="card-body p-0">

                  <div className="row gx-0">
                    <div className="col-xl-12 col-xxl-12 col-lg-12">
                      <div className="dlab-scroll  pt-3 ps-2">

                        <Tab.Container defaultActiveKey={'cars'}>
                          <div role="toolbar" className="toolbar ms-1 ms-sm-0">
                            <div className="saprat">
                              <div className="d-flex align-items-center">

                                <Nav as="ul" className="nav nav-pills" id="pills-tab" role="tablist">

                               


                                  <Nav.Item as="li" className="nav-item btn-group" role="presentation">
                                    <Nav.Link as="button" eventKey={'cars'} type="button" className="btn effect mx-2 nav-link" id="pills-home-tab" >
                                      <i class="fa-solid fa-car"></i>    المركبات                            </Nav.Link>
                                  </Nav.Item>


                                  <Nav.Item as="li" className="nav-item btn-group" role="presentation">
                                    <Nav.Link as="button" eventKey={'invoices'} type="button" className="btn effect mx-2 nav-link" id="pills-home-tab" >
                                      <i class="fa-solid fa-file-invoice-dollar"></i>     الفواتير                                                </Nav.Link>
                                  </Nav.Item>
                                  <Nav.Item as="li" className="nav-item btn-group" role="presentation">
                                    <Nav.Link as="button" eventKey={'maintaince'} type="button" className="btn effect mx-2 nav-link" id="pills-home-tab" >
                                      <i class="fa-solid fa-file-invoice-dollar"></i>     الصيانات القادمة                                                </Nav.Link>
                                  </Nav.Item>
                                </Nav>
                              </div>

                            </div>
                          </div>
                          {/** Single Message */}


                          <Tab.Content>


                         
                            <Tab.Pane eventKey={'cars'}>
                              <Cars orders={orders.vehicles} />



                            </Tab.Pane>
                            <Tab.Pane eventKey={'invoices'}>
                              <div className="table-responsive active-projects dlab-scroll task-table my-2 mx-2" style={{ height: "400px" }}>
                                <table className="table">
                                  <thead style={{ position: "sticky", top: 0, zIndex: 1, color: 'black' }}>                <tr>
                                    <th>رقم الفاتورة</th>
                                    <th>السيارة</th>
                                    <th>القيمة</th>
                                    <th>تاريخ الدفع</th>
                                    <th>البند</th>

                                  </tr>
                                  </thead>
                                  <tbody style={{ color: 'black' }}>
                                    {invoices.length > 0 ? (
                                      invoices.map((invoice) => (
                                        <tr
                                          key={invoice.InvoiceID}
                                          style={{
                                            backgroundColor: colorMap[invoice.RepairOrderID] || "white",
                                          }}
                                        >
                                          <td>{invoice.InvoiceNumber}</td>
                                          <td style={{whiteSpace:'normal'}}>{invoice.Vehicle.MakeName}-{invoice.Vehicle.ModelName}    -{invoice.Vehicle.EngineNumber}-{invoice.Vehicle.LicensePlate}</td>
                                          <td>{invoice.AmountDue}</td>
                                          <td>{invoice.IssueDate}</td>
                                          <td>{invoice.PaymentStatus}</td>


                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="5" style={{ textAlign: "center" }}>
                                          لا توجد فواتير.
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>

                                </table>
                              </div>




                            </Tab.Pane>
                          <Tab.Pane eventKey={'maintaince'}>
                              <div className="table-responsive active-projects dlab-scroll task-table my-2 mx-2" style={{ height: "400px" }}>
<table className="custom-table text-center" style={{ textAlign: 'center' }}>      <thead style={{ position: "sticky", top: 0, zIndex: 1, background: "#f9f9f9" }}>
        <tr>
          <th>رقم الصيانة</th>
          <th>السيارة</th>
          <th>التاريخ القادم</th>
          <th>الفترة (أشهر)</th>
          <th>الفترة (كم)</th>
          <th>الخدمات</th>
          <th>إجراء</th>
        </tr>
      </thead>
      <tbody>
        {orders?.vehicles?.flatMap(vehicle =>
          vehicle.scheduled_maintenances?.map(schedule => (
            <tr key={schedule.id}>
              <td>{schedule.id}</td>
              <td>
                {vehicle.make?.MakeName || ''} - {vehicle.vehicle_model?.ModelName || ''} - {vehicle.LicensePlate}
              </td>
              <td>{schedule.NextDate}</td>
              <td>{schedule.IntervalMonths || '-'}</td>
              <td>{schedule.IntervalKm || '-'}</td>
              <td style={{whiteSpace:'normal'}}>
                {schedule.repair_details?.length > 0
                  ? schedule.repair_details.map(d => d.service?.ServiceName).join(', ')
                  : '-'}
              </td>
              <td>
                <button
                  className="btn btn-success btn-sm"
                  onClick={() => handleTakeAppointment(schedule, vehicle)}
                >
                  حجز موعد
                </button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
</Tab.Pane>





                          </Tab.Content>

                        </Tab.Container>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>



      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>حجز موعد</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>



            <Form.Group className="mb-3">
              <Form.Label>التاريخ</Form.Label>
              <Form.Control
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>الوقت</Form.Label>
              <Form.Control
                type="time"
                value={time}
                onChange={(e) => setTime(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>ملاحظات العميل</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="يمكنك إضافة أي ملاحظات"
                value={customerNote}
                onChange={(e) => setCustomerNote(e.target.value)}
              />
            </Form.Group>

            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? "جارٍ الحفظ..." : "حجز الموعد"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>




    </>
  );
});

export default Orders;
